export default __webpack_public_path__ + "static/media/angpao-bm.fde6295b.webp";